/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".form-formatting[_ngcontent-%COMP%]{width:95%;display:block;margin-left:auto;margin-right:auto;resize:vertical}.danger[_ngcontent-%COMP%]{color:red}"];
export { styles as styles };
